import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleOutput',
  props: {
  value: {
    default: '',
  },
  description: {
    default: '',
  },
  label: {
    default: '',
  },
  isLink: {
    default: false,
  },
  linkType: {
    default: '',
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props
const linksHref = {
  phone: `tel:${props.value}`,
  email: `mailto:${props.value}`,
}

const __returned__ = { props, linksHref, ref, watch, toRefs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})